import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
import graph from "../data/les-miserables.json"

const baseUri = "WebApi.asmx/api/statisticsService";
const store = {};
const mutations = {
    GET_TOPICTYPE_STATS(state, posts) {
        state.topicTypeStats = posts;
    },
    GET_SUCHFELD_STATS(state, posts) {
        state.suchfeldStats = posts;
    },
    GET_STEEP_STATS(state, posts) {
        state.steepStats = posts;
    },
    GET_TOPICBYSUCHFELD_STATS(state, posts) {
        state.topicBySuchfeldStats = posts;
    },
    GET_SUCHFELDBEWERTUNG_STATS(state, posts) {
        state.suchfeldBewertungStats = posts;
    },
    GET_USER_STATS(state, posts) {
        state.userStats = posts;
    },
    GET_VOTING_STATS(state, posts) {
        state.votingStats = posts;
    },
    GET_NETWORK_BY_KEYWORDS(state) {
        state.networkByKeywordsCategories = graph.categories;
        state.networkByKeywordsNodes = graph.nodes;
        state.networkByKeywordsLinks = graph.links;
    },
};
const state = {
    topicTypeStats: [],
    userStats: [],
    votingStats: [],
    suchfeldStats: [],
    suchfeldBewertungStats: [],
    steepStats: [],
    topicBySuchfeldStats:[],
    networkByKeywordsCategories: [],
    networkByKeywordsNodes: [],
    networkByKeywordsLinks: []
};
const getters = {};
const actions = {
    getTopicTypeStats({ commit }, { RtgId, TtyId, StgId, StatusId, PriId, RouId }) {
        axios
            .get(baseUri + '/GetTopicTypeStats?RtgId=' + RtgId + '&TtyId=' + TtyId + '&StgId=' + StgId + '&StatusId=' + StatusId + '&PriId=' + PriId + '&RouId=' + RouId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPICTYPE_STATS', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getSuchfeldStats({ commit }, { RtgId, TtyId, StgId, StatusId, PriId, RouId }) {
        axios
            .get(baseUri + '/GetSuchfeldStats?RtgId=' + RtgId + '&TtyId=' + TtyId + '&StgId=' + StgId + '&StatusId=' + StatusId + '&PriId=' + PriId + '&RouId=' + RouId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_SUCHFELD_STATS', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getSteepStats({ commit }, { AtrId, LisId, RtgId, TtyId, StgId, StatusId, PriId, RouId }) {
        axios
            .get(baseUri + '/GetMultiValueStats?RtgId=' + RtgId + '&AtrId=' + AtrId + '&TtyId=' + TtyId + '&LisId=' + LisId + '&StgId=' + StgId + '&StatusId=' + StatusId + '&PriId=' + PriId + '&RouId=' + RouId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_STEEP_STATS', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getTopicBySuchfeldStats({ commit }, { AtrId, LisId, RtgId, TtyId, StgId, StatusId, PriId, RouId , SufId }) {
        axios
            .get(baseUri + '/GetTopicList?RtgId=' + RtgId + '&AtrId=' + AtrId + '&TtyId=' + TtyId + '&LisId=' + LisId + '&StgId=' + StgId + '&StatusId=' + StatusId + '&PriId=' + PriId + '&RouId=' + RouId + '&SufId=' + SufId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPICBYSUCHFELD_STATS', res.data.data);
                    console.log(res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getSuchfeldBewertungStats({ commit }, { RtgId }) {
        axios
            .get(baseUri + '/GetSuchfeldBewertungStats?RtgId=' + RtgId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_SUCHFELDBEWERTUNG_STATS', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getUserStats({ commit }) {
        axios
            .get(baseUri + '/GetUserStats')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_USER_STATS', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getVotingStats({ commit }) {
        axios
            .get(baseUri + '/GetVotingStats')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_VOTING_STATS', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getNetworkByKeywords({ commit }, { topicId, stgId, rouId }) {
        axios
            .get(baseUri + '/GetNetworkByKeywords?StgId=' + stgId + '&RouId=' + rouId + '&topicId=' + topicId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_NETWORK_BY_KEYWORDS', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}